import type { PageOptions, ResolvedOptions } from './types'
import { join } from 'node:path'
import { globSync } from 'tinyglobby'

import { extsToGlob, slash } from './utils'

/**
 * Resolves the page dirs for its for its given globs
 */
const VUE_MD_EXT_RE = /\/$/
export function getPageDirs(PageOptions: PageOptions, root: string, exclude: string[]): PageOptions[] {
  const dirs = globSync(slash(PageOptions.dir), {
    ignore: exclude,
    onlyDirectories: true,
    dot: true,
    expandDirectories: false,
    cwd: root,
  })

  const pageDirs = dirs.map(dir => ({
    ...PageOptions,
    dir: dir.replace(VUE_MD_EXT_RE, ''),
  }))

  return pageDirs
}

/**
 * Resolves the files that are valid pages for the given context.
 */
export function getPageFiles(path: string, options: ResolvedOptions, pageOptions?: PageOptions): string[] {
  const {
    exclude,
    extensions,
  } = options

  const ext = extsToGlob(extensions)
  const pattern = pageOptions?.filePattern ?? `**/*.${ext}`

  const files = globSync(pattern, {
    ignore: exclude,
    onlyFiles: true,
    cwd: path,
  }).map(p => slash(join(path, p)))

  return files
}
